import React from "react";
import clsx from "clsx";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { SlideDown } from "react-slidedown";
import { videos, videosStop } from "../../../../../assets/icons";
import "react-slidedown/lib/slidedown.css";
import "./styles.scss";

interface HostCardProps {
  host: {
    name: string;
    id: string;
    location: {
      region: string;
      regionIcon: string;
      country: string;
      countryIcon: string;
    };
    jobTitle: string;
    theme: string;
    photo: string;
    linkedIn: string;
    experience: { year: number; title: string }[];
    video: string;
  };
  setActiveHost: () => void;
  canPlay: boolean;
}

export const HostCard = (props: HostCardProps): JSX.Element => {
  const { host, setActiveHost, canPlay } = props;
  const [expanded, setExpanded] = React.useState(false);
  const [playVideo, setPlayVideo] = React.useState(false);

  const handlePlayClick = () => {
    setActiveHost();
    setPlayVideo(!playVideo);
  };

  return (
    <div className="hc">
      <div className={clsx("hc-theme", `${host.id}`)}>
        <h6>{host.theme}</h6>
      </div>
      <div className="hc-media">
        <button onClick={() => handlePlayClick()} type="button">
          <img
            className="hc-media-play"
            src={playVideo && canPlay ? videosStop : videos}
            alt={`play-${host.name}`}
          />

          {playVideo && canPlay ? (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video className="hc-media-host" autoPlay>
              <source src={host.video} type="video/mp4" />
            </video>
          ) : (
            <img
              src={host.photo}
              alt={`host-name-${host.name}`}
              className="hc-media-host"
            />
          )}
        </button>
      </div>
      <div className="hc-name-wrapper">
        <h6 className="hc-name">{host.name}</h6>
        <a href={host.linkedIn} target="_blank" rel="noreferrer">
          <LinkedInIcon />
        </a>
      </div>
      <div className="hc-info">
        <div className="hc-info-location">
          <div>
            <img
              src={host.location.regionIcon}
              alt={`host-region-${host.name}`}
            />
            <h6>{host.location.region}</h6>
          </div>
          <div>
            <img
              src={host.location.countryIcon}
              alt={`host-country-${host.name}`}
            />
            <h6>{host.location.country}</h6>
          </div>
        </div>
        <div className="hc-info-jobTitle">
          <h6>{host.jobTitle}</h6>
        </div>
        <div className="hc-info-experience">
          <ul>
            <button type="button" onClick={() => setExpanded(!expanded)}>
              <li>
                <div className="hc-info-experience-title">
                  <h6>iGEM Experience</h6>
                  {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </div>
              </li>
              <SlideDown className="my-dropdown-slidedown">
                {expanded &&
                  host.experience.map((exp) => (
                    <li key={`${exp.year}-${exp.title}`}>
                      <h6>
                        {exp.year} - {exp.title}
                      </h6>
                    </li>
                  ))}
              </SlideDown>
            </button>
          </ul>
        </div>
      </div>
    </div>
  );
};
